import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock } from "lucide-react";

export const UnassignedB2BMessage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-muted/20 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 rounded-full bg-muted flex items-center justify-center">
            <Lock className="w-8 h-8 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl">Unassigned Memorial</CardTitle>
          <CardDescription className="text-base">
            This memorial medallion has not been activated yet. It needs to be set up by your monument company through their Scan & Assign portal.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center text-sm text-muted-foreground">
          <p>If you purchased this medallion, please contact your monument company to complete the activation process.</p>
        </CardContent>
      </Card>
    </div>
  );
};
